/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import FileSystemType from '../file/system/file-system-type';
import LogicalUnit from '../logical-unit/logical-unit';

/**
 * Třída pro získání a práci s hlavní ukládací cestou BasePath.
 */
class BasePathResolver {
  /**
   * Vytvoří instanci.
   * @param {InternalBasePath} internalDownloadPath Zdroj dat pro vyhledání fyzických jednotek.
   * @param {FileSystemPathFactory} fileSystemPathFactory Zdroj dat pro vyhledání fyzických jednotek.
   * @param {LogicalUnitMapper} logicalUnitMapper Mapovač logických jednotek.
   * @returns {BasePathResolver} Nová instance.
   */
  constructor(internalDownloadPath, fileSystemPathFactory, logicalUnitMapper) {
    this.internalDownloadPath = internalDownloadPath;
    this.fileSystemPathFactory = fileSystemPathFactory;
    this.logicalUnitMapper = logicalUnitMapper;
  }

  /**
   * Vrátí basePath pro danou logickou jednotku.
   * @param {FileSystemPath} logicalPath
   * @returns {Promise<FileSystemUnit|null>}
   */
  toPhysicalPath(logicalPath) {
    const logicalUnitName = logicalPath.getUnit();
    return this.logicalUnitMapper
      .toFileSystemUnit(new LogicalUnit(logicalUnitName))
      .then((fileSystemUnit) => {
        const fileSystemUnitName = fileSystemUnit.getName();

        return this.fileSystemPathFactory.fromValue(
          // TODO: udelat nejak jinak nez replace
          logicalPath.getValue().replace(logicalUnitName, fileSystemUnitName)
        );
      });
  }

  /**
   * Vrátí basePath pro danou logickou jednotku.
   * @param {LogicalUnit} logicalUnit
   * @returns {Promise<FileSystemUnit|null>}
   */
  resolve(logicalUnit) {
    return new Promise((resolve) =>
      resolve(
        this.logicalUnitMapper
          .toFileSystemUnit(logicalUnit)
          .then((fileSystemUnit) => {
            if (
              fileSystemUnit.getType() === FileSystemType.Usb ||
              fileSystemUnit.getType() === FileSystemType.SdCard
            ) {
              return this.fileSystemPathFactory.fromValue(
                `/${logicalUnit.getName()}/player-lighter/asset`
              );
            }

            return this.internalDownloadPath.resolve(logicalUnit);
          })
      )
    );
  }
}

export default BasePathResolver;
